import styled, { css } from 'styled-components'
import { Collection as BaseCollection, CollectionItem as BaseCollectionItem, Photo as BasePhoto } from '../Collection'

const isSelected = css`
  &:before {
    content: 'Wybrane';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    font-size: 20px;
    font-weight: 600;
    color: ${props => props.theme.colors.white};
    z-index: 1;
    border-radius: 6px;
  }
`

export const Header = styled.h4`
  display: block;
  width: 100%;
  margin-bottom: 10px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 500;
  border-bottom: 1px solid ${props => props.theme.colors.secondaryLight};
  text-transform: uppercase;
`

export const Collection = styled(BaseCollection)`
  & + ${Header} {
    margin-top: 30px;
  }
`

export const CollectionItem = styled(BaseCollectionItem)`
  ${props => props.isSelected && isSelected};
`

export const Tools = styled.div`
  display: ${props => (props.isActive ? 'flex' : 'none')};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
  flex-flow: wrap column;
`

export const ToolsButtons = styled.a`
  display: inline-block;
  padding: 3px 15px;
  background: ${props => props.theme.colors.hover};
  margin-bottom: 7px;
  border-radius: 4px;
  color: ${props => props.theme.colors.white};
  font-size: 12px;
  transition: all 0.3s ease;

  &:hover {
    color: black;
  }
`

export const Photo = styled(BasePhoto)``



// WEBPACK FOOTER //
// ./src/components/CollectionWallpapers/theme.js